const PlanStarterSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="185"
      height="188"
      viewBox="0 0 185 188"
      fill="none"
    >
      <path
        d="M116.696 8.95599C116.696 8.95599 85.2679 -0.796007 56.7079 18.2C28.1479 37.192 15.8399 72.94 5.10394 101.612C-5.62806 130.284 4.13994 158.54 28.0719 170.564C51.9999 182.588 66.0199 162.688 98.0479 160.336C130.076 157.984 139.084 162.292 164.236 142.58C189.388 122.868 190.688 78.876 167.076 47.412C143.464 15.948 116.7 8.95599 116.7 8.95599H116.696Z"
        fill="#0038FF"
      />
      <path
        opacity="0.7"
        d="M116.696 8.95599C116.696 8.95599 85.2679 -0.796007 56.7079 18.2C28.1479 37.192 15.8399 72.94 5.10394 101.612C-5.62806 130.284 4.13994 158.54 28.0719 170.564C51.9999 182.588 66.0199 162.688 98.0479 160.336C130.076 157.984 139.084 162.292 164.236 142.58C189.388 122.868 190.688 78.876 167.076 47.412C143.464 15.948 116.7 8.95599 116.7 8.95599H116.696Z"
        fill="white"
      />
      <path
        d="M177.992 110.872H184.944"
        stroke="#222222"
        stroke-miterlimit="10"
      />
      <path
        d="M23.3199 110.872H174.468"
        stroke="#222222"
        stroke-miterlimit="10"
      />
      <path
        d="M0.171997 110.872H18.984"
        stroke="#222222"
        stroke-miterlimit="10"
      />
      <path
        d="M170.088 84.612C169.948 84.612 169.808 84.592 169.668 84.548L76.7399 55.556L26.9079 64.82C26.1439 64.96 25.4079 64.456 25.2679 63.692C25.1239 62.928 25.6319 62.192 26.3959 62.052L76.5719 52.724C76.7999 52.684 77.0279 52.696 77.2479 52.764L170.508 81.86C171.248 82.092 171.664 82.88 171.432 83.624C171.244 84.228 170.688 84.612 170.088 84.612Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M90.084 107.54C89.76 107.54 89.468 107.312 89.396 106.984L75.016 46.204C74.62 44.336 73.164 42.848 71.304 42.412L66.032 41.18C65.652 41.092 65.42 40.712 65.508 40.336C65.596 39.956 65.976 39.724 66.352 39.812L71.624 41.044C74.012 41.604 75.884 43.516 76.392 45.916L90.772 106.696C90.852 107.076 90.608 107.448 90.228 107.532C90.18 107.544 90.128 107.548 90.08 107.548L90.084 107.54Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M164.064 97.576C163.988 97.576 163.908 97.564 163.832 97.536L81.688 70.456L32.128 82.104C31.756 82.208 31.364 81.992 31.26 81.62C31.156 81.248 31.372 80.856 31.744 80.752L81.52 69.04C81.66 69 81.808 69.004 81.944 69.052L164.296 96.208C164.664 96.336 164.856 96.736 164.728 97.104C164.628 97.396 164.356 97.576 164.064 97.576Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M157.836 115.38C157.76 115.38 157.684 115.368 157.608 115.34L85.956 89.304L38.144 104.36C37.772 104.468 37.38 104.248 37.276 103.876C37.172 103.504 37.388 103.112 37.76 103.008L85.784 87.892C85.924 87.852 86.068 87.856 86.204 87.904L158.068 114.012C158.436 114.14 158.628 114.54 158.504 114.908C158.404 115.2 158.132 115.38 157.84 115.38H157.836Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M42.352 61.944L40.968 62.2L53.844 118.568C53.92 118.896 54.208 119.116 54.528 119.116C54.58 119.116 54.632 119.112 54.684 119.1C55.064 119.012 55.3 118.636 55.212 118.256L42.348 61.944H42.352Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M58.624 58.92L57.24 59.176L69.364 113.34C69.436 113.668 69.728 113.888 70.048 113.888C70.1 113.888 70.152 113.884 70.204 113.872C70.584 113.788 70.82 113.412 70.736 113.032L58.624 58.92Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M71.3 56.564L69.916 56.82L81.72 109.536C81.792 109.864 82.084 110.084 82.404 110.084C82.456 110.084 82.508 110.08 82.56 110.068C82.94 109.984 83.176 109.608 83.092 109.228L71.3 56.56V56.564Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M135.42 73.86L125.912 118.716C125.82 119.092 126.048 119.476 126.424 119.568C126.48 119.584 126.536 119.588 126.592 119.588C126.908 119.588 127.196 119.376 127.276 119.052L136.768 74.276L135.42 73.856V73.86Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M121.596 69.548C121.548 69.624 121.512 69.708 121.496 69.804L115.132 114.964C115.064 115.348 115.316 115.712 115.7 115.78C115.744 115.788 115.784 115.792 115.824 115.792C116.156 115.792 116.456 115.552 116.516 115.212L122.88 70.052C122.888 70.016 122.888 69.984 122.888 69.948L121.596 69.544V69.548Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M151.688 78.936C151.688 78.936 151.688 78.94 151.688 78.944L138.596 123.112C138.48 123.484 138.688 123.876 139.056 123.992C139.128 124.016 139.196 124.024 139.268 124.024C139.568 124.024 139.844 123.832 139.94 123.532L153.032 79.364V79.356L151.692 78.936H151.688Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M109.16 65.668C109.128 65.736 109.108 65.808 109.1 65.884L105.112 111.836C105.072 112.224 105.352 112.568 105.74 112.608C105.764 112.608 105.788 112.608 105.812 112.608C106.168 112.608 106.472 112.34 106.512 111.976L110.496 66.08L109.164 65.664L109.16 65.668Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M96.76 61.8L95.164 108.416C95.152 108.804 95.46 109.128 95.848 109.14C95.856 109.14 95.86 109.14 95.868 109.14C96.248 109.14 96.56 108.84 96.572 108.456L98.156 62.236L96.764 61.8H96.76Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M151.456 127.808C151.36 127.808 151.26 127.792 151.164 127.76L90.744 108.044L44.312 123.084C43.82 123.244 43.292 122.972 43.132 122.48C42.972 121.988 43.2439 121.46 43.7359 121.3L90.456 106.164C90.644 106.104 90.848 106.104 91.036 106.164L151.744 125.972C152.236 126.132 152.504 126.664 152.344 127.156C152.216 127.552 151.848 127.804 151.452 127.804L151.456 127.808Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M120.376 140.624C120.28 140.624 120.184 140.608 120.088 140.58L54.4519 119.632C53.9599 119.472 53.6879 118.944 53.8479 118.452C54.0079 117.96 54.5359 117.688 55.0279 117.848L120.664 138.796C121.156 138.956 121.428 139.484 121.268 139.976C121.14 140.372 120.772 140.628 120.376 140.628V140.624Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M132.66 135.824C132.56 135.824 132.456 135.808 132.356 135.772L70.0079 114.272C69.5199 114.104 69.2599 113.568 69.4279 113.08C69.5959 112.592 70.1319 112.332 70.6199 112.5L132.972 134C133.46 134.168 133.72 134.704 133.552 135.192C133.42 135.58 133.056 135.824 132.664 135.824H132.66Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M142.928 131.128C142.828 131.128 142.728 131.112 142.628 131.08L82.176 110.624C81.684 110.456 81.424 109.924 81.588 109.436C81.756 108.944 82.284 108.68 82.776 108.848L143.228 129.304C143.72 129.472 143.98 130.004 143.816 130.492C143.684 130.884 143.32 131.128 142.928 131.128Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M95.3213 184.529C97.8016 183.103 98.4379 179.556 96.7425 176.607C95.0471 173.657 91.6621 172.422 89.1818 173.848C86.7015 175.273 86.0652 178.82 87.7606 181.77C89.4559 184.719 92.841 185.954 95.3213 184.529Z"
        fill="#222222"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M94.8639 178.26C95.8959 180.052 95.5079 182.208 93.9999 183.072C92.4919 183.94 90.4359 183.188 89.4079 181.396C88.3759 179.604 88.7639 177.448 90.2719 176.584C91.7799 175.716 93.8359 176.468 94.8639 178.26Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M91.6439 170.604L89.9679 178.82C89.7959 179.664 90.1559 180.532 90.8759 181.004C91.7439 181.572 92.8999 181.424 93.5959 180.652L99.9479 173.592L91.6399 170.604H91.6439Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M126.782 170.093C129.262 168.668 129.899 165.121 128.203 162.171C126.508 159.222 123.123 157.986 120.643 159.412C118.162 160.838 117.526 164.385 119.221 167.334C120.917 170.284 124.302 171.519 126.782 170.093Z"
        fill="#222222"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M126.328 163.824C127.36 165.616 126.972 167.772 125.464 168.636C123.956 169.504 121.9 168.752 120.872 166.96C119.84 165.168 120.228 163.012 121.736 162.148C123.244 161.284 125.3 162.032 126.328 163.824Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M123.104 156.168L121.428 164.384C121.256 165.228 121.616 166.096 122.336 166.568C123.204 167.136 124.36 166.988 125.056 166.216L131.408 159.156L123.1 156.168H123.104Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M86.0119 149.48C87.7079 152.432 87.0719 155.976 84.5919 157.404C82.1119 158.828 78.7239 157.596 77.0279 154.644C75.3319 151.692 75.9679 148.148 78.4479 146.72C80.9279 145.296 84.3159 146.528 86.0119 149.48Z"
        fill="#222222"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M83.2698 155.946C84.7771 155.08 85.1637 152.924 84.1333 151.131C83.1028 149.339 81.0456 148.588 79.5382 149.454C78.0309 150.32 77.6443 152.476 78.6747 154.269C79.7052 156.062 81.7624 156.812 83.2698 155.946Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M80.9118 143.476L79.2358 151.692C79.0638 152.536 79.4238 153.404 80.1438 153.876C81.0118 154.444 82.1678 154.296 82.8638 153.524L89.2158 146.464L80.9078 143.476H80.9118Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M53.056 161.988C54.752 164.94 54.116 168.484 51.636 169.912C49.156 171.336 45.768 170.104 44.076 167.152C42.38 164.2 43.016 160.656 45.496 159.228C47.976 157.804 51.364 159.036 53.056 161.988Z"
        fill="#222222"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M51.1799 163.64C52.2119 165.432 51.8239 167.588 50.3159 168.452C48.8079 169.316 46.7519 168.568 45.7239 166.776C44.6919 164.984 45.0799 162.828 46.5879 161.964C48.0959 161.096 50.1519 161.848 51.1799 163.64Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M47.96 155.984L46.284 164.2C46.112 165.044 46.472 165.912 47.192 166.384C48.06 166.952 49.216 166.804 49.912 166.032L56.264 158.972L47.956 155.984H47.96Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M104.764 175.388C103.764 175.388 102.756 175.228 101.78 174.908L44.1599 156.044C42.5639 155.524 41.2719 154.336 40.6079 152.796C39.8759 151.084 40.0039 149.108 40.9559 147.508L53.1239 126.772C53.4519 126.22 54.1119 125.96 54.7319 126.14L94.7559 137.996C95.4999 138.216 95.9279 138.996 95.7079 139.744C95.4879 140.488 94.7079 140.916 93.9599 140.696L76.1639 135.456C76.1599 135.492 76.1519 135.528 76.1439 135.564L76.0239 136.084C75.7359 137.304 76.0599 138.588 76.8879 139.528C77.3639 140.068 77.9839 140.464 78.6719 140.672L134.392 157.44C135.332 157.724 135.988 158.536 136.068 159.516C136.148 160.492 135.628 161.4 134.748 161.832L108.956 174.416C107.632 175.064 106.204 175.388 104.768 175.388H104.764ZM55.2239 128.912L43.3759 148.944C42.8839 149.772 42.8159 150.796 43.1959 151.684C43.5399 152.484 44.2079 153.096 45.0359 153.368L102.66 172.232C104.34 172.784 106.136 172.656 107.72 171.884L132.48 159.804L77.8599 143.368C76.6679 143.008 75.5999 142.324 74.7759 141.392C73.3439 139.772 72.6799 137.444 73.1759 135.34L73.2959 134.824C73.3159 134.736 73.3439 134.652 73.3799 134.572L55.2239 128.92V128.912Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M76.0239 136.084L76.1679 135.456L73.3839 134.564L73.1759 135.332C72.9559 136.272 73.0639 137.336 73.2439 138.26L76.8679 139.5C76.0519 138.564 75.7359 137.288 76.0199 136.076L76.0239 136.084Z"
        fill="#222222"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.152 52.296C14.736 52.296 13.5 51.192 13.292 49.656C13.064 47.972 14.16 46.412 15.74 46.172L63.652 38.828C65.232 38.588 66.7 39.752 66.924 41.436C67.152 43.12 66.056 44.68 64.476 44.92L16.564 52.264C16.424 52.284 16.284 52.296 16.148 52.296H16.152Z"
        fill="#222222"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M28.8879 65.256C28.5719 65.256 28.2839 65.044 28.2039 64.724L25.8799 55.42C25.4239 53.596 23.9999 52.204 22.1639 51.792L14.7479 50.128C14.3679 50.044 14.1319 49.668 14.2159 49.288C14.2999 48.908 14.6799 48.672 15.0559 48.756L22.4719 50.42C24.8319 50.948 26.6599 52.736 27.2479 55.08L29.5719 64.384C29.6679 64.76 29.4359 65.144 29.0599 65.236C29.0039 65.252 28.9439 65.256 28.8879 65.256Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M93.4439 60.48L52.2999 69.4L108.404 87.524L144.944 76.304L93.4439 60.48Z"
        fill="#0038FF"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M76.0559 64.112L128.78 81.608"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M108.404 87.524L106.388 139.028L54.3119 121.188L52.2999 69.4L108.404 87.524Z"
        fill="#0038FF"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M144.944 76.304L141.204 125.504L106.388 139.028L108.404 87.524L144.944 76.304Z"
        fill="#0038FF"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M111.148 144.528C111.076 144.528 111.008 144.516 110.94 144.496L43.2319 123.42C42.9959 123.348 42.8199 123.156 42.7599 122.92L28.2119 64.724C28.1159 64.348 28.3479 63.964 28.7239 63.872C29.0999 63.776 29.4839 64.008 29.5759 64.384L44.0279 122.196L111.12 143.08L151.46 126.872L169.44 82.94C169.588 82.58 169.996 82.408 170.356 82.556C170.716 82.704 170.888 83.112 170.74 83.472L152.648 127.676C152.576 127.852 152.436 127.992 152.26 128.064L111.412 144.476C111.328 144.508 111.24 144.528 111.148 144.528Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M111.148 144.528C111.116 144.528 111.08 144.528 111.048 144.52C110.664 144.464 110.396 144.108 110.452 143.724L117.168 97.28C117.224 96.896 117.576 96.628 117.964 96.684C118.348 96.74 118.616 97.096 118.56 97.48L111.844 143.924C111.792 144.276 111.492 144.528 111.148 144.528Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M121.592 140.236C121.544 140.236 121.492 140.232 121.444 140.22C121.064 140.14 120.824 139.764 120.904 139.384L130.604 94.62C130.688 94.24 131.064 94 131.44 94.08C131.82 94.164 132.06 94.536 131.98 94.916L122.28 139.68C122.208 140.008 121.916 140.236 121.592 140.236Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M133.344 135.76C133.288 135.76 133.228 135.752 133.172 135.74C132.796 135.644 132.568 135.26 132.664 134.884L143.668 91.424C143.764 91.048 144.148 90.82 144.524 90.916C144.9 91.012 145.128 91.392 145.032 91.772L134.028 135.232C133.948 135.552 133.66 135.764 133.348 135.764L133.344 135.76Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M143.6 131.096C143.532 131.096 143.464 131.088 143.392 131.064C143.02 130.952 142.812 130.556 142.924 130.184L156.168 86.912C156.284 86.54 156.676 86.332 157.048 86.444C157.42 86.556 157.628 86.952 157.516 87.324L144.272 130.596C144.18 130.9 143.9 131.092 143.6 131.092V131.096Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M99.3959 140.052C99.3959 140.052 99.3679 140.052 99.3559 140.052C98.9679 140.032 98.6719 139.7 98.6919 139.312L101.304 91.936C101.324 91.548 101.644 91.244 102.044 91.272C102.432 91.292 102.728 91.624 102.708 92.012L100.096 139.388C100.076 139.764 99.7639 140.052 99.3919 140.052H99.3959Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M88.5758 137.068C88.1918 137.068 87.8798 136.76 87.8718 136.376L86.9398 86.576C86.9318 86.188 87.2398 85.868 87.6318 85.86C88.0038 85.836 88.3398 86.16 88.3478 86.548L89.2798 136.348C89.2878 136.736 88.9798 137.056 88.5878 137.064H88.5758V137.068Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M77.7599 133.336C77.3879 133.336 77.0759 133.044 77.0559 132.664L74.6319 81.932C74.6119 81.544 74.9119 81.216 75.2999 81.196C75.6919 81.168 76.0159 81.476 76.0359 81.864L78.4599 132.6C78.4799 132.988 78.1799 133.316 77.7919 133.336C77.7799 133.336 77.7679 133.336 77.7559 133.336H77.7599Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M68.0599 130.352C67.6999 130.352 67.3959 130.08 67.3599 129.712L62.5119 77.672C62.4759 77.284 62.7599 76.944 63.1479 76.908C63.5319 76.872 63.8759 77.156 63.9119 77.544L68.7599 129.584C68.7959 129.972 68.5119 130.316 68.1239 130.348C68.0999 130.348 68.0799 130.348 68.0559 130.348L68.0599 130.352Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M59.1039 127.928C58.7639 127.928 58.4639 127.684 58.4119 127.336L49.6439 72.684C49.5839 72.3 49.8439 71.94 50.2279 71.876C50.6079 71.812 50.9719 72.076 51.0359 72.46L59.8039 127.112C59.8639 127.496 59.6039 127.856 59.2199 127.92C59.1839 127.924 59.1439 127.928 59.1079 127.928H59.1039Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M50.7119 124.944C50.3919 124.944 50.1039 124.724 50.0279 124.4L36.9719 68.444C36.8839 68.064 37.1199 67.688 37.4959 67.6C37.8759 67.512 38.2519 67.748 38.3399 68.124L51.3959 124.08C51.4839 124.46 51.2479 124.836 50.8719 124.924C50.8199 124.936 50.7639 124.944 50.7119 124.944Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M115.812 114.124C115.792 114.124 115.772 114.124 115.756 114.124C113.3 113.936 39.8079 85.936 31.4359 82.744C31.0719 82.604 30.8919 82.2 31.0279 81.836C31.1679 81.472 31.5719 81.288 31.9359 81.428C54.4719 90.02 113.476 112.392 115.872 112.72H115.884C117.916 112.72 146.468 103.376 165.196 97.084C165.564 96.96 165.964 97.16 166.088 97.528C166.212 97.896 166.012 98.296 165.644 98.42C157.796 101.056 118.752 114.124 115.808 114.124H115.812Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M113.944 130.536C112.996 130.536 59.2038 111.856 36.1198 103.824C35.7518 103.696 35.5598 103.296 35.6878 102.928C35.8158 102.56 36.2158 102.368 36.5838 102.496C62.2798 111.436 111 128.324 113.952 129.116C116.096 128.544 141.9 118.98 159.024 112.576C159.388 112.44 159.792 112.624 159.928 112.988C160.064 113.352 159.88 113.756 159.516 113.892C142.892 120.108 114.868 130.536 113.944 130.536Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M121.776 99.16C121.616 99.16 121.452 99.132 121.3 99.076L26.1759 64.756C25.4439 64.492 25.0679 63.688 25.3319 62.956C25.5959 62.224 26.4039 61.844 27.1319 62.112L121.82 96.272L169.684 81.856C170.428 81.632 171.212 82.052 171.436 82.796C171.66 83.54 171.24 84.324 170.496 84.548L122.188 99.096C122.056 99.136 121.92 99.156 121.784 99.156L121.776 99.16Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M74.268 25.704L42.708 29.052L84.952 39.4L113.14 33.752L74.268 25.704Z"
        fill="#0038FF"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M61.4561 26.868L101.012 36.448"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M84.952 39.4L83.764 77.28L44.02 64.872L42.708 29.052L84.952 39.4Z"
        fill="#0038FF"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M113.14 33.752L110.896 66.812L83.764 77.28L84.952 39.4L113.14 33.752Z"
        fill="#0038FF"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M119.916 51.784L77.86 62.056L105.96 71.748L148.6 61.864L119.916 51.784Z"
        fill="#0038FF"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M105.96 71.748V89.58L77.6639 79.308L77.8599 62.056L105.96 71.748Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M105.96 89.58L148.792 75.236L148.6 61.864L105.96 71.748V89.58Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M119.92 40.544L76.6079 49.996L105.552 59.976L149.46 48.528L119.92 40.544Z"
        fill="#0038FF"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M105.552 59.976V78.336L76.408 67.76L76.608 49.996L105.552 59.976Z"
        fill="#0038FF"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M105.552 78.336L149.66 64.732L149.46 48.528L105.552 59.976V78.336Z"
        fill="#0038FF"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M87.0841 0.975998L62.9041 3.54L95.2721 11.472L116.556 8.632L87.0841 0.975998Z"
        fill="#0038FF"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M77.692 1.98799L108.18 9.87199"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M95.272 11.472L94.104 41.332L61.916 31.172L62.904 3.53999L95.272 11.472Z"
        fill="#0038FF"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M116.556 8.632L115.12 35.392L94.104 41.332L95.272 11.472L116.556 8.632Z"
        fill="#0038FF"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default PlanStarterSvg
